export enum ButtonVariant {
  Default = "default",
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary",
  Positive = "positive",
  Destructive = "destructive",
  Ghost = "ghost",
  GhostDestructive = "ghost-destructive",
  ActionPrimary = "action-primary",
  ActionCritical = "action-critical",
}

export enum AlertVariant {
  Danger = "danger",
  Info = "info",
}

export enum BadgeVariant {
  Danger = "danger",
  Default = "default",
  Info = "info",
  Success = "success",
  Warning = "warning",
  Brown = "brown",
  Purple = "purple",
  Teal = "teal",
  Orange = "orange",
  Grey = "grey",
}

export enum ComponentSize {
  xxs = "xxs",
  xs = "xs",
  sm = "sm",
  md = "md",
  default = "default",
  lg = "lg",
  xl = "xl",
  xl2 = "2xl",
  xl3 = "3xl",
  xl4 = "4xl",
  xl5 = "5xl",
  xl6 = "6xl",
}

export enum ComponentColor {
  Teal = "teal",
  Orange = "orange",
  Purple = "purple",
  Brown = "brown",
  Blue = "blue",
  Red = "red",
  Green = "green",
  Yellow = "yellow",
  Pink = "pink",
  Grey = "grey",
}

export enum AvatarType {
  Sophie = "sophie",
  Webshop = "webshop",
  Homerunner = "homerunner",
  User = "user",
  Carrier = "carrier",
  Icon = "icon",
  CheckoutLogo = "checkout-logo",
}

export enum ScanState {
  DEFAULT = "default",
  DEFAULT_OPEN_UNIT = "default_open_unit",
  LOADING = "loading",
  CONSIGNMENT_BOOKED = "consignment-booked",
  NO_UNIT_SELECTED = "no_unit_selected",
  NO_ACTIVE_CONSIGNMENTS = "no_active_consignments",
  SELECTED_READY = "selected_ready",
  SELECTED_SHIPMENT_ADDED = "selected_shipment_added",
  SELECTED_SHIPMENT_MOVED = "selected_shipment_moved",
  SELECTED_WRONG_UNIT = "selected_wrong_unit",
  SELECTED_UNIT_NOT_FOUND = "selected_unit_not_found",
  SCAN_FAILED = "scan_failed",
  SELECTED_CLOSED_UNIT = "selected_closed_unit",
  SELECTED_ALREADY_ADDED = "selected_already_added",
  READY_TO_CLOSE = "ready_to_close",
  CONSIGNMENT_CLOSED = "consignment_closed",
  ERROR_CLOSING = "error_closing",
}
